"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardIcon = void 0;
const react_1 = __importDefault(require("react"));
const SVGIcon_1 = require("../SVGIcon");
const DashboardIcon = props => (react_1.default.createElement(SVGIcon_1.SVGIcon, Object.assign({}, props, { viewBox: "2 2 20 20" }),
    react_1.default.createElement("path", { d: "M13.3815 19.2797C13.0957 20.3467 11.999 20.9798 10.9321 20.6939C9.86512 20.408 9.23196 19.3114 9.51784 18.2444C9.80373 17.1775 13.3908 11.5176 13.3908 11.5176C13.3908 11.5176 13.6674 18.2128 13.3815 19.2797Z" }),
    react_1.default.createElement("path", { d: "M12 4C12.7688 4 13.5151 4.0964 14.2275 4.27777L13.7097 6.21028C13.1625 6.07293 12.5898 6 12 6C8.13401 6 5 9.13401 5 13C5 14.5124 5.47964 15.9128 6.29511 17.0573L5.12652 18.8102C3.79989 17.2424 3 15.2146 3 13C3 8.02944 7.02944 4 12 4Z" }),
    react_1.default.createElement("path", { 
        // opacity="0.6"
        d: "M18.8737 18.8102C20.2003 17.2424 21.0002 15.2146 21.0002 13C21.0002 9.5091 19.0127 6.48239 16.1075 4.98975L15.5742 6.97991C17.6257 8.20042 19.0002 10.4397 19.0002 13C19.0002 14.5124 18.5206 15.9128 17.7051 17.0574L18.8737 18.8102Z" })));
exports.DashboardIcon = DashboardIcon;
exports.default = exports.DashboardIcon;
